/**
 * @generated SignedSource<<8e22348370f10bf10e6b653eda44335f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type EditMcpServerRouteTestMutation$variables = {
  id: any;
};
export type EditMcpServerRouteTestMutation$data = {
  readonly testCustomMcpServerConnection: {
    readonly error: string | null | undefined;
    readonly oauthUrl: string | null | undefined;
    readonly success: boolean;
    readonly tools: ReadonlyArray<string>;
  };
};
export type EditMcpServerRouteTestMutation = {
  response: EditMcpServerRouteTestMutation$data;
  variables: EditMcpServerRouteTestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "TestConnectionPayload",
    "kind": "LinkedField",
    "name": "testCustomMcpServerConnection",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tools",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oauthUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditMcpServerRouteTestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditMcpServerRouteTestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c46d4061410c58f53fd6d109ad926103",
    "id": null,
    "metadata": {},
    "name": "EditMcpServerRouteTestMutation",
    "operationKind": "mutation",
    "text": "mutation EditMcpServerRouteTestMutation(\n  $id: GlobalID!\n) {\n  testCustomMcpServerConnection(id: $id) {\n    success\n    tools\n    error\n    oauthUrl\n  }\n}\n"
  }
};
})();

(node as any).hash = "4d1630228477355d81744332788de7a5";

export default node;
